import { useEffect } from 'react'

const useHeapInit = (): void => {
  // Only load this once
  useEffect(() => {
    if (!globalThis.heap || !process.env.NEXT_PUBLIC_HEAP_APP_ID) {
      return
    }

    globalThis.heap.load(process.env.NEXT_PUBLIC_HEAP_APP_ID)
  }, [])
}

export default useHeapInit
